import styled from 'styled-components'
import { Box } from '~/components/Box'
import { ReactComponent as IconTool } from '~/assets/images/settings.svg'

export const StyledExchangePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.bgColor};

  p {
    margin: 0;
  }
`

export const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 1200px;

  ${({ theme }) => theme.media.sm`
    gap: 0;
  `}
`

export const StyledFormContainer = styled.div<{ withActivity: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 68px auto 0;

  ${({ theme }) => theme.media.sm`
    width: 100%;
    margin: 72px auto 0;
    padding: 0 15px;
    
    ${({ withActivity }) => withActivity && 'margin-top: 18px;'}
  `}
`

export const StyledExchangeBox = styled.div<{ hide: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({ hide }) => hide && 'display: none;'}
`

export const StyledSettingsBtnContainer = styled.div`
  position: absolute;
  top: -46px;
  right: 44px;
  cursor: pointer;
`

export const StyledSettingsWrapper = styled.span`
  position: relative;
  width: 32px;
  height: 32px;
`

export const StyledIconSettings = styled(IconTool)`
  width: 32px;
  height: 32px;
  cursor: pointer;
`

export const StyledRedDot = styled.span`
  display: inline-block;
  position: absolute;
  top: 2px;
  right: 3px;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #f45d5d;
`

export const StyledBoxContainer = styled(Box)`
  height: 100%;
  width: 100%;
`

export const StyledDisabledMask = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2;
  position: absolute;
  width: 480px;
  height: 400px;
  border-radius: 16px;
`

export const StyledMainArea = styled.div`
  position: relative;
`

export const StyledMainAreaInner = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  .balance {
    position: relative;
    font-size: 12px;
    text-align: right;
    letter-spacing: 0.4px;
    color: #867db3;
    margin-top: 7px;
    font-weight: 500;
    margin-bottom: 6px;
    margin-right: 15px;
    .wallet-icon {
      margin-left: 8px;
    }
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #2c2842;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
`

export const StyledDetailWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 20px;
  color: ${({ theme }) => theme.colors.textGrey2};
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`
